/// <reference path="../../../../ts/libs.ts" />
import { DropdownButtonType, List, ListItem, ListProps, SingleSelectDropdown } from '@tableau/widgets';
import * as React from 'react';
import { CommonStyles } from '../../../../common/react/CommonStyles';
import { IViewInfo } from '../../../../ts/models/IViewInfo';

interface DevicePreviewNavigationToolsState {
  currentDashboardIndex: number;
}

export interface DevicePreviewNavigationToolsProps {
  dashboardList: IViewInfo[];
  startingDashboardIndex: number;
  onNewDashboardSelected: (newDashboard: IViewInfo) => void;
}

export class DevicePreviewNavigationTools extends React.Component<DevicePreviewNavigationToolsProps, DevicePreviewNavigationToolsState> {
  private sizeStyling: React.CSSProperties = {
    maxWidth: 225,
    fontSize: 14
  };

  private textStyling: React.CSSProperties = {
    color: CommonStyles.Colors.Grey230,
    fontFamily: CommonStyles.Fonts.HeaderFont,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    ...this.sizeStyling
  };

  public state: DevicePreviewNavigationToolsState = {
    currentDashboardIndex: this.props.startingDashboardIndex
  };

  public render(): JSX.Element {
    if (this.props.dashboardList === undefined || this.props.dashboardList.length === 0) {
      return null;
    }

    const value = this.props.dashboardList[this.state.currentDashboardIndex].name;

    const listProps: ListProps = {
      items: this.getListItemsFromDashboards(),
      selectedValue: value
    };

    const dropdownProps = {
      list: <List {...listProps} style ={this.sizeStyling} />,
      onChange: this.onDropdownValueChanged,
      type: DropdownButtonType.Text,
      useDarkStyling: true,
      value: value,
      testId: 'device-preview-dropdown-control'
    };

    return (
      <span className="tb-preview-navigation-tools-container">
        <SingleSelectDropdown {...dropdownProps}>
          <span style={this.textStyling}>{ value }</span>
        </SingleSelectDropdown>
      </span>
    );
  }

  private getListItemsFromDashboards = (): ListItem[] => {
    return this.props.dashboardList.map((item) => {
      return {
        value: item.name,
        testId: `device-preview-dashboard-list-item-${item.name}`
      };
    });
  }

  private onDropdownValueChanged = (newValue: string) => {
    const newIndex = this.props.dashboardList.findIndex(dashboard => dashboard.name === newValue);
    this.setState({ currentDashboardIndex: newIndex });
    this.props.onNewDashboardSelected(this.props.dashboardList[newIndex]);
  }
}
